import { NgModule } from '@angular/core';
import { DialogAfipComponent } from './dialog-afip.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [DialogAfipComponent],
  imports: [MatDialogModule, MatButtonModule]
})
export class DialogAfipModule {}
